export default [
  {
    Leaders: [],
  },
  {
    TechnicalMembers: [
      {
        Name: "Wasim Alam",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Abdus Samad",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Varun Kumar Singh",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Usama Zahid",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Afeera Laiq",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Zakir Nihal Siddiqui",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Adnan Hussain",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Md ShafatUllah",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Umair Abrar",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Zayyan Ullah Khan",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Rudra Agrawal",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Gufran Khan",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Noor Yamshi",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mohd Ahmed",
        Post: "Team Green Warriors",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },

  // {
  //   WebDeveloper: [
  //     {
  //       Name: "Chhaya Chaudhary",
  //       Post: "Web Developer",
  //       LinkedIn: "https://www.linkedin.com/in/chhaya-chaudhary-963362287",
  //       Insta: "",
  //       Email: "chhayachaudhary1212@gmail.com",
  //     },
  //     {
  //       Name: "Khushnuma",
  //       Post: "Web Developer",
  //       LinkedIn: "/https:/www.linkedin.com/in/khushnuma-237309295",
  //       Insta: "",
  //       Email: "khushnumaa65@gmail.com",
  //     },
  //   ],
  // },
];
